import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-d0960fe8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "发货信息", -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "收货信息", -1); });
var _hoisted_5 = { class: "submit-box" };
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("提交");
import { ref } from "vue";
import { Form, Field, Popup, NavBar, Button, Cell, Toast, Icon, TimePicker, } from "vant";
import { sendingExpress, queryExpressInfo } from "@/api";
import { useRoute, useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SendingExpress',
    setup: function (__props) {
        var _this = this;
        var _a, _b;
        var route = useRoute();
        var router = useRouter();
        var onLoadloading = ref(true);
        if (((_a = route.query) === null || _a === void 0 ? void 0 : _a.sendStatus) === "2") {
            queryExpressInfo((_b = route.query) === null || _b === void 0 ? void 0 : _b.orderId)
                .then(function (res) {
                console.log(res.data);
                address.value = res.data.senderAddress;
                sender.value = res.data.sender;
                senderPhone.value = res.data.senderPhone;
                // sendTime.value = [];
                // sendDate.value = [];
                dateLabel.value = res.data.sendTime.substring(0, res.data.sendTime.lastIndexOf(":"));
            })
                .catch(function () {
                onLoadloading.value = false;
                Toast("网络错误-08");
            });
        }
        var address = ref("");
        var sender = ref("");
        var senderPhone = ref("");
        var formRef = ref();
        var toTwoDigits = function (num) {
            return num < 10 ? "0" + num : num.toString();
        };
        var sendTime = ref([
            toTwoDigits(new Date().getHours() + 1),
            toTwoDigits(new Date().getMinutes()),
        ]);
        console.log(sendTime.value);
        var sendDate = ref([]);
        var dateLabel = ref();
        var datePickerVisible = ref(false);
        var handleDateSelect = function (date) {
            dateLabel.value =
                date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) +
                    "-" +
                    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
            datePickerVisible.value = false;
            timePickerVisible.value = true;
            sendDate.value = dateLabel.value;
        };
        var timePickerVisible = ref(false);
        var handleTimeSelect = function (_a) {
            var selectedValues = _a.selectedValues;
            dateLabel.value = dateLabel.value + " " + selectedValues.join(":");
            timePickerVisible.value = false;
            sendTime.value = selectedValues;
        };
        var loading = ref(false);
        var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                formRef.value.validate().then(function () { return __awaiter(_this, void 0, void 0, function () {
                    var res;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                loading.value = true;
                                return [4 /*yield*/, sendingExpress({
                                        orderId: route.query.orderId,
                                        receiver: "王建山",
                                        receiverAddress: "河北省廊坊市安次区慧谷梦工厂58号",
                                        receiverPhone: "13323165797",
                                        sendTime: dateLabel.value + ":00",
                                        sender: sender.value,
                                        senderAddress: address.value,
                                        senderPhone: senderPhone.value,
                                        storeUserId: localStorage.getItem("userId"),
                                    }).catch(function () {
                                        Toast("网络错误-07");
                                        loading.value = false;
                                    })];
                            case 1:
                                res = _a.sent();
                                loading.value = false;
                                if (res.code === 200) {
                                    Toast("呼叫快递成功");
                                    router.replace("/salesman-sending-express-success");
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        var now = new Date();
        var minDate = ref(new Date(now.getFullYear(), now.getMonth(), now.getDate()));
        return function (_ctx, _cache) {
            var _component_van_calendar = _resolveComponent("van-calendar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "发快递",
                    onClickLeft: _cache[0] || (_cache[0] =
                        function () {
                            _unref(router).go(-1);
                        })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Form), {
                        ref_key: "formRef",
                        ref: formRef
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_3,
                            _createVNode(_unref(Field), {
                                modelValue: address.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((address).value = $event); }),
                                label: "发货地址",
                                placeholder: "请输入您的发货地址",
                                rules: [{ required: true, message: '请输入您的发货地址' }]
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(Field), {
                                modelValue: sender.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((sender).value = $event); }),
                                label: "姓名",
                                placeholder: "请输入您的姓名",
                                rules: [{ required: true, message: '请输入您的姓名' }]
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(Field), {
                                modelValue: senderPhone.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((senderPhone).value = $event); }),
                                label: "手机号",
                                placeholder: "请输入您的手机号",
                                rules: [
                                    { required: true, message: '请输入您的手机号' },
                                    { pattern: /^1\d{10}$/, message: '请填写正确的手机号' },
                                ]
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(Field), {
                                modelValue: dateLabel.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((dateLabel).value = $event); }),
                                "is-link": "",
                                readonly: "",
                                label: "上门时间",
                                placeholder: "请选择快递上门时间",
                                onClick: _cache[5] || (_cache[5] = function ($event) { return (datePickerVisible.value = true); }),
                                rules: [{ required: true, message: '请选择快递上门时间' }]
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_van_calendar, {
                                show: datePickerVisible.value,
                                "onUpdate:show": _cache[6] || (_cache[6] = function ($event) { return ((datePickerVisible).value = $event); }),
                                title: "选择日期",
                                onConfirm: handleDateSelect,
                                onCancel: _cache[7] || (_cache[7] =
                                    function () {
                                        datePickerVisible.value = false;
                                        dateLabel.value = '';
                                    }),
                                "min-date": minDate.value
                            }, null, 8, ["show", "min-date"]),
                            _createVNode(_unref(Popup), {
                                show: timePickerVisible.value,
                                "onUpdate:show": _cache[10] || (_cache[10] = function ($event) { return ((timePickerVisible).value = $event); }),
                                position: "bottom"
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_unref(TimePicker), {
                                        modelValue: sendTime.value,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((sendTime).value = $event); }),
                                        onConfirm: handleTimeSelect,
                                        onCancel: _cache[9] || (_cache[9] =
                                            function () {
                                                timePickerVisible.value = false;
                                                dateLabel.value = '';
                                            })
                                    }, null, 8, ["modelValue"])
                                ]; }),
                                _: 1
                            }, 8, ["show"]),
                            _hoisted_4,
                            _createVNode(_unref(Cell), { title: "收货地址（系统默认，不可更改）" }),
                            _createVNode(_unref(Cell), {
                                title: "王建山",
                                value: "13323165797",
                                label: "河北省廊坊市安次区慧谷梦工厂58号"
                            }),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(Button), {
                                    color: "#3DABA4",
                                    size: "large",
                                    round: "",
                                    onClick: handleSubmit,
                                    loading: loading.value
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_6
                                    ]; }),
                                    _: 1
                                }, 8, ["loading"])
                            ])
                        ]; }),
                        _: 1
                    }, 512)
                ])
            ]));
        };
    }
});
